import React, { FC, PropsWithChildren } from 'react';
import { TextDanger } from './typography/TextDanger';
import { TextEllipsis } from './TextEllipsis';

export interface RequiredTextProps {
  required?: boolean | null;
}

export const RequiredText: FC<PropsWithChildren<RequiredTextProps>> = ({
  children,
  required = true,
}) => (
  <TextEllipsis>
    {required ? (
      <>
        <TextDanger>* </TextDanger>
        {children}
      </>
    ) : (
      children
    )}
  </TextEllipsis>
);
